








































import Vue from "vue";
import changelogs from "../../utils/changelog";

export default Vue.extend({
	name: "ChangelogComp",
	data: () => ({
		versions: changelogs,
	}),
});
